import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "qeditor-toolbar"
}
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "select-size ms-1" }
const _hoisted_4 = ["value"]

import { ref, computed, watch, onMounted } from 'vue'
import { QUESTION_SURVEY_TYPES, QUESTION_TEST_TYPES } from '../const/question-types'
import QuestionType from '../lib/QuestionType'
import ToolbarComponent from './ToolbarComponent.vue'
import { qEditorState } from '../stores'
import { editorEventBus } from '../stores/eventBus'


export default /*@__PURE__*/_defineComponent({
  __name: 'EditorToolbarComponent',
  setup(__props, { expose: __expose }) {

const currentLine = computed(() => qEditorState.currentLine)
const previousLine = computed(() => qEditorState.previousLine)
const question = computed(() => qEditorState.question)

const fontSize = ref('12')

const fontSizes = () => {
  const list: string[] = []
  for (let index = 8; index < 40; index = index + 2) {
    list.push(`${index}`)
  }
  return list
}

const isRevisionMode = computed(() => qEditorState.isRevisionMode)

const colors = ref({
  hex: '#000000',
  hsl: { h: 150, s: 0, l: 0, a: 1 },
  hsv: { h: 150, s: 0, l: 0, a: 1 },
  rgba: { r: 0, g: 0, b: 0, a: 1 },
  a: 1
})

const onColorChange = (event: Event) => {
  const color = (event.target as HTMLInputElement).value
  colors.value.hex = color
  addColor(color)
}

const surveyTypes = computed(() => QUESTION_SURVEY_TYPES)
const testTypes = computed(() => QUESTION_TEST_TYPES)

const emitEvent = (data: { event: string; payload?: any }) => {
  editorEventBus.emit(data.event, data.payload)
}
// Expose event bus for EditorComponent to use
__expose({ editorEventBus })

watch(fontSize, () => {
  emitEvent({
    event: 'insertSnippet',
    payload: {
      type: 'fontsize',
      fontSize: fontSize.value
    }
  })
}, { immediate: true })

const heading = () => {
  emitEvent({
    event: 'insertSnippet',
    payload: {
      type: 'heading',
      content: '# ${1:内容}\n'
    }
  })
  emitEvent({ event: 'focus' })
}

const bold = () => {
  emitEvent({
    event: 'insertSnippet',
    payload: {
      type: 'bold',
      content: '** ${1:内容} **'
    }
  })
  emitEvent({ event: 'focus' })
}

const quote = () => {
  emitEvent({
    event: 'insertSnippet',
    payload: {
      type: 'quote',
      content: '> ${1:内容}\n'
    }
  })
  emitEvent({ event: 'focus' })
}

const link = () => {
  emitEvent({
    event: 'insertSnippet',
    payload: {
      type: 'link',
      content: '[${1:タイトル}](${2:http://}) '
    }
  })
  emitEvent({ event: 'focus' })
}

const list = () => {
  emitEvent({
    event: 'insertSnippet',
    payload: {
      type: 'list',
      content: '- ${1:内容}\n'
    }
  })
  emitEvent({ event: 'focus' })
}

const onMathLiveClick = () => {
  emitEvent({
    event: 'insertSnippet',
    payload: {
      type: 'mathlive'
    }
  })
  emitEvent({ event: 'focus' })
}

const insertQuestion = (question_type: QuestionType) => {
  let sampleCode = question_type.sampleCode
  if (question_type.fieldType != 'textfield') {
    if (question.value!.fieldType) {
      sampleCode = '\n---\n' + sampleCode
    } else if (currentLine.value != '') {
      sampleCode = '\n\n' + sampleCode
    } else if (previousLine.value != '') {
      sampleCode = '\n' + sampleCode
    }
  } else if (question.value!.fieldType && question.value!.fieldType != 'textfield') {
    sampleCode = '\n---\n' + sampleCode
  }

  emitEvent({
    event: 'insertSnippet',
    payload: {
      content: sampleCode
    }
  })
  emitEvent({ event: 'focus' })
}

const addColor = (color: string) => {
  emitEvent({
    event: 'insertSnippet',
    payload: {
      type: 'color',
      content: color
    }
  })
  emitEvent({ event: 'focus' })
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card = _resolveComponent("v-card")!

  return (!isRevisionMode.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          class: "d-flex justify-content-center align-items-center",
          style: {"width":"30px"},
          onClick: heading
        }, [
          _createCommentVNode(" https://icons.getbootstrap.com/icons/type-h1/ "),
          _cache[2] || (_cache[2] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "currentColor",
            class: "bi bi-type-h1",
            viewBox: "0 0 16 16"
          }, [
            _createElementVNode("path", { d: "M8.637 13V3.669H7.379V7.62H2.758V3.67H1.5V13h1.258V8.728h4.62V13h1.259zm5.329 0V3.669h-1.244L10.5 5.316v1.265l2.16-1.565h.062V13h1.244z" })
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("a", {
          class: "d-flex justify-content-center align-items-center",
          style: {"width":"30px"},
          onClick: bold
        }, [
          _createCommentVNode(" https://icons.getbootstrap.com/icons/type-bold/ "),
          _cache[3] || (_cache[3] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "currentColor",
            class: "bi bi-type-bold",
            viewBox: "0 0 16 16"
          }, [
            _createElementVNode("path", { d: "M8.21 13c2.106 0 3.412-1.087 3.412-2.823 0-1.306-.984-2.283-2.324-2.386v-.055a2.176 2.176 0 0 0 1.852-2.14c0-1.51-1.162-2.46-3.014-2.46H3.843V13H8.21zM5.908 4.674h1.696c.963 0 1.517.451 1.517 1.244 0 .834-.629 1.32-1.73 1.32H5.908V4.673zm0 6.788V8.598h1.73c1.217 0 1.88.492 1.88 1.415 0 .943-.643 1.449-1.832 1.449H5.907z" })
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("a", {
          class: "d-flex justify-content-center align-items-center",
          style: {"width":"30px"},
          onClick: quote
        }, [
          _createCommentVNode(" https://icons.getbootstrap.com/icons/quote/ "),
          _cache[4] || (_cache[4] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "currentColor",
            class: "bi bi-quote",
            viewBox: "0 0 16 16"
          }, [
            _createElementVNode("path", { d: "M12 12a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1h-1.388c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 9 7.558V11a1 1 0 0 0 1 1h2Zm-6 0a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1H4.612c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 3 7.558V11a1 1 0 0 0 1 1h2Z" })
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("a", {
          class: "d-flex justify-content-center align-items-center",
          style: {"width":"30px"},
          onClick: link
        }, [
          _createCommentVNode(" https://icons.getbootstrap.com/icons/link-45deg/ "),
          _cache[5] || (_cache[5] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "currentColor",
            class: "bi bi-link-45deg",
            viewBox: "0 0 16 16"
          }, [
            _createElementVNode("path", { d: "M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z" }),
            _createElementVNode("path", { d: "M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z" })
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("a", {
          class: "d-flex justify-content-center align-items-center",
          style: {"width":"30px"},
          onClick: list
        }, [
          _createCommentVNode(" https://icons.getbootstrap.com/icons/list-task/ "),
          _cache[6] || (_cache[6] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "currentColor",
            class: "bi bi-list-task",
            viewBox: "0 0 16 16"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"
            }),
            _createElementVNode("path", { d: "M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z" }),
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"
            })
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("a", {
          class: "d-flex justify-content-center align-items-center",
          style: {"width":"30px"},
          onClick: onMathLiveClick
        }, [
          _createCommentVNode(" https://icons.getbootstrap.com/icons/alt/ "),
          _cache[7] || (_cache[7] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "currentColor",
            class: "bi bi-alt",
            viewBox: "0 0 16 16"
          }, [
            _createElementVNode("path", { d: "M1 13.5a.5.5 0 0 0 .5.5h3.797a.5.5 0 0 0 .439-.26L11 3h3.5a.5.5 0 0 0 0-1h-3.797a.5.5 0 0 0-.439.26L5 13H1.5a.5.5 0 0 0-.5.5zm10 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5z" })
          ], -1 /* CACHED */))
        ]),
        _createVNode(_component_v_menu, null, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("a", _mergeProps(props, {
              class: "d-flex justify-content-center align-items-center",
              style: {"width":"30px","height":"100%","cursor":"pointer"}
            }), [
              _createCommentVNode(" https://icons.getbootstrap.com/icons/patch-question/ "),
              _cache[8] || (_cache[8] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                fill: "currentColor",
                class: "bi bi-patch-question",
                viewBox: "0 0 16 16"
              }, [
                _createElementVNode("path", { d: "M8.05 9.6c.336 0 .504-.24.554-.627.04-.534.198-.815.847-1.26.673-.475 1.049-1.09 1.049-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.71 1.71 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745z" }),
                _createElementVNode("path", { d: "m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z" }),
                _createElementVNode("path", { d: "M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0z" })
              ], -1 /* CACHED */))
            ], 16 /* FULL_PROPS */)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_subheader, null, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("アンケート", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveyTypes.value, (questionType) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: questionType.label,
                    onClick: ($event: any) => (insertQuestion(questionType))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(questionType.label), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                }), 128 /* KEYED_FRAGMENT */)),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_list_subheader, null, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("テスト", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testTypes.value, (questionType) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: questionType.label,
                    onClick: ($event: any) => (insertQuestion(questionType))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(questionType.label), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_menu, null, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("a", _mergeProps(props, {
              class: "d-flex justify-content-center align-items-center",
              style: {"width":"30px","height":"100%","cursor":"pointer"}
            }), [
              _createCommentVNode(" https://icons.getbootstrap.com/icons/palette/ "),
              _cache[11] || (_cache[11] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                fill: "currentColor",
                class: "bi bi-palette",
                viewBox: "0 0 16 16"
              }, [
                _createElementVNode("path", { d: "M8 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm4 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM5.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" }),
                _createElementVNode("path", { d: "M16 8c0 3.15-1.866 2.585-3.567 2.07C11.42 9.763 10.465 9.473 10 10c-.603.683-.475 1.819-.351 2.92C9.826 14.495 9.996 16 8 16a8 8 0 1 1 8-8zm-8 7c.611 0 .654-.171.655-.176.078-.146.124-.464.07-1.119-.014-.168-.037-.37-.061-.591-.052-.464-.112-1.005-.118-1.462-.01-.707.083-1.61.704-2.314.369-.417.845-.578 1.272-.618.404-.038.812.026 1.16.104.343.077.702.186 1.025.284l.028.008c.346.105.658.199.953.266.653.148.904.083.991.024C14.717 9.38 15 9.161 15 8a7 7 0 1 0-7 7z" })
              ], -1 /* CACHED */))
            ], 16 /* FULL_PROPS */)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-2" }, {
              default: _withCtx(() => [
                _createElementVNode("input", {
                  type: "color",
                  value: colors.value.hex,
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (onColorChange($event))),
                  class: "color-picker-input"
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            class: "editor-button",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fontSize).value = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fontSizes(), (size) => {
              return (_openBlock(), _createElementBlock("option", {
                key: size,
                value: size
              }, _toDisplayString(size) + "px", 9 /* TEXT, PROPS */, _hoisted_4))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vModelSelect, fontSize.value]
          ])
        ]),
        _createVNode(ToolbarComponent)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})